import { css, Dialog, styled } from '@mui/material';

const dialogPageGap = 8;

export const DialogStyled = styled(Dialog)`
  ${({ theme }) => css`
    & .MuiDialog-paper {
      max-width: calc(100% - ${theme.spacing(dialogPageGap * 2)});
    }
  `}
`;
